// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconSafetyDistancing = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M4 1v6h2V5h12v2h2V1h-2v2H6V1z" />,
    <path
      fillRule="evenodd"
      d="M6 15a3 3 0 100-6 3 3 0 000 6m0-2a1 1 0 100-2 1 1 0 000 2m5 5.314c-2.5-2.844-7.083-3.318-10 0V23h10zm-8 .823V21h6v-1.858c-1.68-1.439-4.166-1.601-6-.005M18 15a3 3 0 100-6 3 3 0 000 6m0-2a1 1 0 100-2 1 1 0 000 2m5 5.314c-2.5-2.844-7.083-3.318-10 0V23h10zm-8 .823V21h6v-1.858c-1.68-1.439-4.166-1.601-6-.005"
    />
  );
export default SvgIconSafetyDistancing;
